module.exports = __webpack_public_path__ + "072cbb47b4bc64eee6508bf040bb4fd5.png";